import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import Container from '../../Core/Container';
import image from '../../../images/chevron-right_black.svg';

export const StyledContainer = styled(Container)`
  margin-bottom: -20px;
  margin-top: 30px;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    margin-bottom: -35px;
    margin-top: 40px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    margin-bottom: -75px;
  }

  &.credit-card {
    margin-top: 1rem;
    margin-bottom: 0.5rem;
  }
`;

export const Wrapper = styled.ul`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  padding: 15px 0;
  max-width: 910px;
  padding-right: 10px;

  && {
    margin: 0 -15px;
  }

  li:not(:first-child) {
    margin-top: 0;
  }

  li {
    position: relative;
    padding: 0 15px;
    margin-bottom: 0.75rem;

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      margin-bottom: 0;
    }

    &::after {
      content: '';
      position: absolute;
      background-image: url(${image});
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      width: 8px;
      height: 15px;
      right: -5px;
      top: 50%;
      transform: translateY(-50%);
    }
  }
`;
